import { render } from "./AttributeGroupModule.vue?vue&type=template&id=238f3a2a&scoped=true"
import script from "./AttributeGroupModule.vue?vue&type=script&lang=js"
export * from "./AttributeGroupModule.vue?vue&type=script&lang=js"

import "./AttributeGroupModule.vue?vue&type=style&index=0&id=238f3a2a&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238f3a2a"]])

export default __exports__